import { render, staticRenderFns } from "./ExhibitionsBannerComingSoonDe.vue?vue&type=template&id=05a3442a&"
import script from "./ExhibitionsBannerComingSoonDe.vue?vue&type=script&lang=js&"
export * from "./ExhibitionsBannerComingSoonDe.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionsBannerComingSoonDe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports